/* 
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview Wait for something to be ready to call it
 *  Use property to catch the appearance of the property...
 */
(function($g) {
    "use strict";
    var CHECK_INTERVAL = 50;
    var CHECK_TIME_OUT = 1000 * 60;
    var CHECK_MAX = CHECK_TIME_OUT / CHECK_INTERVAL;
    
    /*function clearProp(base, prop, nv) {
        Object.defineProperty(base, prop, {
            configurable: true,
            writable: true,
            value: nv
        });
    }
    
    function callAll(items, nv) {
        for (var i in items) {
            items[i](nv);
        }
    }
    
    function createListener(base, prop) {
        var items = [];
        items.callAll = callAll;
        Object.defineProperty(base, prop, {
           configurable: true,
           get: function() {
               return items;
           },
           set: function(nv) {
               clearProp(base, prop, nv);
               callAll(items);
           } 
        });  
        return items;
    }
    
    function listenForProp(base, prop, f) {
        var e = base[prop];
        if (e) {
            if (e.callAll===callAll) {
                e.push(f);
            } else {
                f(e);
            }
        } else {
            e = createListener(base, prop);
            e.push(f);
        }        
    }*/
    
    function listenForProp(base, prop, f, l) {
        var e = base[prop];
        if (e) {
            f(e);
            /*if (e.callAll===callAll) {
                e.push(f);
            } else {
                f(e);
            }*/
        } else {
            /*e = createListener(base, prop);
            e.push(f);*/
            if (l>CHECK_MAX) {
                $g.warning("Timed out waiting for delayed item", base, prop);
                f();
            } else {
                setTimeout(function() {
                    listenForProp(base, prop, f, (l||0)+1);
                }, CHECK_INTERVAL);
            }
        }        
    }
    
    /**
     * Wait for one property
     */
    function waitForProp(base, prop, f) {
        var pt = prop.indexOf("."); 
        if (pt >= 0) {
            var sub = prop.substr(0, pt);
            waitForProp(base, sub, function(ad) {
                var n = prop.substr(pt+1);
                waitForProp(ad, n, f);
            });
        } else {
            listenForProp(base, prop, f);
        }        
    }
    
    /**
     * Wait for a list of items
     * dynamics argument
     */
    function waitFor() {
        var i = 0;
        var args = Array.prototype.slice.call(arguments);
        var l = args.length;
        var ll = l-1;
        var endfn = args[ll];
        var legacymode = typeof endfn === "function";
        var base = window;
        var collected = [];
        function next() {
            if (i<l) {
                var o = args[i];
                i++;
                var t = typeof o;
                if (legacymode&&i===l) {
                    o.apply(null, collected);
                    next();
                } else if (t==="string") {
                    if (legacymode) {
                        waitForProp(base, o, function(r) {
                            collected.push(r);
                            next();
                        });
                    } else {
                        return new Promise(function(accept, reject) {
                            waitForProp(base, o, function(r) {
                                if (r) {
                                    collected.push(r);
                                    accept();
                                } else {
                                    reject(o);
                                }
                            });    
                        }).then(next);
                    }
                } else {
                    base = o;
                    return next();
                }
            } else {
                return Promise.resolve(collected);
            }
        }
        return next();
        /*if (typeof f !== "function" && typeof prop === "function") {
            waitFor(window, base, prop);
        } else {
            var pt = prop.indexOf("."); 
            if (pt >= 0) {
                var sub = prop.substr(0, pt);
                waitFor(base, sub, function(ad) {
                    var n = prop.substr(pt+1);
                    waitFor(ad, n, f);
                });
            } else {
                listenForProp(base, prop, f);
            }
        }*/
    }
        
    $g.waitFor = waitFor;
    /*$g.wait = function() {
        var args = Array.prototype.slice.call(arguments);
        return new Promise(function(accept) {
            waitFor(null, ...args, function(...params) {
                accept(...params);
            });
        });
    };*/
        
    window._w = waitFor;
})(PVPGEngine);